import {
	type PartnerReviewCreateDto,
	postOrdersReviewOrderId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.partnerReviewMutations;

export const useCreatePartnerReviewMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: PartnerReviewCreateDto) =>
			postOrdersReviewOrderId(data, orderId),
		),
		onError: (error) => {
			console.error(`${t(orderMutationsResource.addReviewError)}:`, error);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: orderKeys.review(orderId) });
			queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) });
			toast.success(t(orderMutationsResource.addReviewSuccess));
		},
	});
};
